import Backbone from 'backbone';
import EventHub from '~/eventHub';
import Settings from '~/settings.js';
import AppView from '~/appView';
import LoginView from '~/views/loginView';
import ReportView from '~/views/reportView';
import CategoryView from '~/views/categoryView';
import ProfileView from '~/views/profileView';
import SelectCategoryView from '~/views/selectCategoryView';
import AdminCategoriesView from '~/views/admincategoriesView';
import AdminLanguagesView from '~/views/adminlanguagesView';
import SendPushNotificationsView from '~/views/sendpushnotificationsView';
import ChartsView from '~/views/chartsView';
import FlutterSocialContactsView from '~/views/flutter/flutterSocialContactsView';
import FlutterSocialEmailsView from '~/views/flutter/flutterSocialEmailsView';
import FlutterSocialPlansView from '~/views/flutter/flutterSocialPlansView';
import NewsView from '~/views/newsView';
import ChangelogView from '~/views/changelogView';
import TimelineView from '~/views/tra-timelineView';
import GraphsView from '~/views/tra-graphsView';
import ChartsFlutterView from '~/views/chartsFlutterView';
import MenuView from '~/views/tra-menuView';
import TablesView from '~/views/tra-tablesView';
import UseraddView from '~/views/useraddView';
import ProfilesView from '~/views/profilesView';
import UsersView from '~/views/usersView';
import NotificationsView from '~/views/notificationsView';
import FirstLoginView from '~/views/firstLoginView';
import Req2FAView from '~/views/req2FAView';
import SupportTicketsView from '~/views/supportTicketsView';
import SupportTicketView from '~/views/supportTicketView';
import GuidesView from '~/views/guidesView';
import MultiAppBusView from '~/views/multiappbusView';
import URIJS from 'urijs';
import toastr from 'toastr';
import getUserService from '~/services/userService';
import getReportCategoryService from '~/services/reportCategoryService';
import getReportSubCategoryService from '~/services/reportSubCategoryService';
import getReportService from '~/services/reportService';
import getUtilsService from '~/services/utilsService';

String.prototype.format = function() {
  var i = 0,
  args = arguments;
  return this.replace(/{}/g, function() {
    return typeof args[i] != 'undefined' ? args[i++] : '';
  });
};

var AppRouter = Backbone.Router.extend({
  currentLayout: null,
  viewCache: {},
  routes: {
    "timeline(?*querystring)": "tratimelineViewer",
    "graphs" : "chartsFlutterViewer",
    "social_contacts" : "flutterSocialContacts",
    "social_emails" : "flutterSocialEmails",
    "social_plans" : "flutterSocialPlans",
    "tables(?*querystring)" : "tratablesViewer",
    "menu" : "tramenuViewer",
    "user/:id(/:type)": "userViewer",
    "report(/:id)": "reportViewer",
    "category(?*querystring)": "categoryViewer",
    "login(?uri=*path)": "loginViewer",
    "personal(?*querystring)": "personalViewer",
    "personal(/:id?*querystring)": "personalViewer",
    "profile": "profileViewer",
    "useradd": "useraddViewer",
    "profiles": "profilesViewer",
    "users": "usersViewer",
    "sendpushnotifications" : "sendpushnotificationsViewer",
    "admincategories" : "admincategoriesViewer",
    "adminlanguages" : "adminlanguagesViewer",
    "charts(?*queryString)" : "chartsViewer",
    'news': 'newsViewer',
	  'changelog': 'changelogViewer',
    "notifications": "notificationsViewer",
	  "firstlogin": "firstLoginViewer",
    "req2fauth": "req2FAViewer",
	  'supportTickets': 'supportTicketsViewer',
    "supportTicket(/:id)": "supportTicketViewer",
    "guides(?*querystring)": "guidesViewer",
    "multiappbus": "multiappbusViewer",
    '*notFound': 'personalViewer',
  },

  initialize: function() {
    toastr.options = {"closeButton": true,"positionClass": "toast-top-center"};
    this.appView = new AppView({ el: $('.app')});
    this.appView.render();
  },

	//don't delete
	execute: function(callback, args, name) {
    getUserService().isSessionInvalid().then((invalid) => {
		  if(!invalid){
				if (!getUserService().isAuthorized()) {
					var currentRoute = Backbone.history.getFragment();
					if(args.length >1 && args[1]=='reset') {
						currentRoute ='';
					}
					if (currentRoute.indexOf('login') != 0) {
						setTimeout(() => {
							EventHub.trigger('navigate', 'login?url='+currentRoute, {
								trigger: true
							});
						}, 0);
						return false;
					}
				}
				var permissions = getUtilsService.getprofilepermissions();
        var Settingpermissions = {
          "userViewer":"",
          "reportViewer":"reports",
          "categoryViewer":"reports",
          "personalViewer":"",
          "profileViewer":"",
          "useraddViewer":"addusers",
          "profilesViewer":"profiles",
          "usersViewer":"consultusers",
          "sendpushnotificationsViewer":"news",
          "admincategoriesViewer":"admincategories",
          "chartsViewer":"reportcharts",
          "tragraphsViewer":"usercharts",
          'newsViewer':"news",
        }
				if(Settingpermissions[name] && Settingpermissions[name] != "" && !permissions[Settingpermissions[name]]){
					EventHub.trigger('navigate', 'personal', {
						trigger: true
					});
					return false;
				}
				else{
					if(getUserService().isAuthorized() && !permissions){
						getUserService().logOut();
						return false;
					}
				}
				if((!window.localStorage.pushInfo || window.localStorage.pushInfo ==  '') && getUserService().isAuthorized()){
					this.serviceWorkerStart().then(() => {

					},
					(error) => {
						console.log(error);
						window.localStorage.pushInfo = '';
					});
				}
				// pass to next route
				if (callback) callback.apply(this, args);
		  } else {
				getUtilsService.handleInvalidSession();
		    return false;
		  }
		}).catch(e => {
		  toastr.warning('Error de Servidor.',"Aviso");
		});
	},

	serviceWorkerStart: async function() {
		var sw = await navigator.serviceWorker.ready;
		var push = await sw.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: Settings.pushNotifPublicKey
		});
		window.localStorage.pushInfo = JSON.stringify(push);
		var data = {
			pushInfo: JSON.parse(JSON.stringify(push))
		};
		Parse.Cloud.run("suscribeWebPushUser", data).then(() => {});
	},

  showLayout: function(layoutName, getLayout, layoutType) {
    this.currentLayout = layoutName;
    this.appView.renderLayout(getLayout(), layoutType);
  },

  loginViewer: function(backToUri) {
	this.showLayout('personal', () => ({content: new LoginView()}), 'fullwidth-light');
  },

  firstLoginViewer: function(backToUri) {
    this.showLayout('personal', () => ({content: new FirstLoginView()}), 'fullwidth-light');
  },

  multiappbusViewer: function(backToUri) {
    this.showLayout('multiappbus', () => ({content: new MultiAppBusView()}), 'fullwidth-light');
  },
  
  req2FAViewer: function(backToUri) {
    this.showLayout('personal', () => ({content: new Req2FAView()}), 'fullwidth-light');
  },

	tratimelineViewer: function(querystring){
		EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    var uri = new URIJS('?' + querystring);
		var query = uri.search(true);
    var trazabilidad = false;
    switch(query.kind){
      case 'user':
        trazabilidad = getUtilsService.getprofilepermissions().trazabilidaduser;
      break;
      case 'report':
        trazabilidad = getUtilsService.getprofilepermissions().trazabilidadreport;
      break;
    }
    if (trazabilidad != true) {
			toastr.warning('No tiene permiso para esta sección.',"Aviso");
			this.personalViewer();
		}
		else {
			EventHub.trigger('sidebarView:setActive', '#timeline');
			EventHub.trigger('header:setName', 'Línea de Tiempo');
			this.showLayout('timeline', () => ({'content-row': [new TimelineView()]}));
			EventHub.trigger('report:timeline', {ID: query.id, kind: query.kind, username: query.username});
		}

  },

  tratablesViewer: function(querystring){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    var uri = new URIJS('?' + querystring);
    var query = uri.search(true);
    var trazabilidad = false;
    switch(query.kind){
      case 'user':
        trazabilidad = getUtilsService.getprofilepermissions().trazabilidaduser;
      break;
      case 'report':
        trazabilidad = getUtilsService.getprofilepermissions().trazabilidadreport;
      break;
    }
    if (trazabilidad != true) {
      toastr.warning('No tiene permiso para esta sección.',"Aviso");
      this.personalViewer();
    }else{
      EventHub.trigger('sidebarView:setActive', '#table');
      EventHub.trigger('header:setName', 'Tabla');
      this.showLayout('timeline', () => ({'content-row': [new TablesView()]}));
      EventHub.trigger('report:table', {ID: query.id,kind: query.kind, username: query.username});
    }
  },
  tragraphsViewer: function(){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#graphs');
    EventHub.trigger('header:setName', 'Gráficos de Usuarios');
    this.showLayout('timeline', () => ({'content-row': [new GraphsView()]}));
  },
  chartsFlutterViewer: function(){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#graphs');
    EventHub.trigger('header:setName', 'Analíticas');
    this.showLayout('chartsFlutter', () => ({'content-row': [new ChartsFlutterView()]}));
  },
  flutterSocialContacts: function(){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#social_contacts');
    EventHub.trigger('header:setName', 'Lista de Contactos');
    this.showLayout('chartsFlutter', () => ({'content-row': [new FlutterSocialContactsView()]}));
  },
  flutterSocialEmails: function(){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#social_emails');
    EventHub.trigger('header:setName', 'Campañas de Socialización');
    this.showLayout('chartsFlutter', () => ({'content-row': [new FlutterSocialEmailsView()]}));
  },
  flutterSocialPlans: function(){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#social_planes');
    EventHub.trigger('header:setName', 'Planes');
    this.showLayout('chartsFlutter', () => ({'content-row': [new FlutterSocialPlansView()]}));
  },

  tramenuViewer: function(){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#menu');
    EventHub.trigger('header:setName', 'Menu');
    this.showLayout('timeline', () => ({'content-row': [new MenuView()]}));
  },

  profileViewer: function(id) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#profile');
    EventHub.trigger('header:setName', 'Perfil de Usuario');
    this.showLayout('profile', () => ({'content-row': [new ProfileView()]}));
    EventHub.trigger('user:setUser', {id: Parse.User.current()});
  },

  useraddViewer: function(id) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#adduser');
    EventHub.trigger('header:setName', 'Agregar de Usuario');
    this.showLayout('addusers', () => ({'content-row': [new UseraddView()]}));
  },

  profilesViewer: function(id) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#profiles');
    EventHub.trigger('header:setName', 'Perfiles');
    this.showLayout('profiles', () => ({'content-row': [new ProfilesView()]}));
  },

  usersViewer: function(id) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#users');
    EventHub.trigger('header:setName', 'Usuarios');
    var usersPromise = getUserService().fetch({
      all: true,
      cache: false
    });
    this.showLayout('users', () => ({'content-row': [new UsersView()]}));
  },

  newsViewer: function(id) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#news');
    EventHub.trigger('header:setName', 'Noticias');
    this.showLayout('news', () => ({'content-row': [new NewsView()]}));
  },
  
  supportTicketsViewer: function(id) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#supportTickets');
    EventHub.trigger('header:setName', 'Soporte');
    this.showLayout('news', () => ({'content-row': [new SupportTicketsView()]}));
  },

  changelogViewer: function(id) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#changelog');
  	EventHub.trigger('header:setName', 'Changelog');
    this.showLayout('changelog', () => ({'content-row': [new ChangelogView()]}));
  },

  notificationsViewer: function(id) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#notifications');
    EventHub.trigger('header:setName', 'Notificaciones');
    this.showLayout('notifications', () => ({'content-row': [new NotificationsView()]}));
  },

 chartsViewer:function(querystring){
  EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
  EventHub.trigger('sidebarView:setActive', querystring);
  EventHub.trigger('header:setName', 'Gráficos de Reportes');
  this.showLayout('admin-category', () => ({'content-row': [new ChartsView()],}));
  EventHub.trigger('dataforchart', querystring);
 },

  admincategoriesViewer: function(){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#admincategories');
    EventHub.trigger('header:setName', 'Categorias');
    this.showLayout('admin-category', () => ({'content-row': [new AdminCategoriesView()],}));
  },

  adminlanguagesViewer: function(){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#adminlanguages');
    EventHub.trigger('header:setName', 'Lenguajes');
    this.showLayout('admin-language', () => ({'content-row': [new AdminLanguagesView()],}));
  },

  sendpushnotificationsViewer: function(){
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#admincategories');
    EventHub.trigger('header:setName', 'Enviar Noticias');
    this.showLayout('admin-category', () => ({'content-row': [new SendPushNotificationsView()],}));
  },

  personalViewer: function(querystring = null) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    var uri = new URIJS('?' + querystring);
    var query = uri.search(true);
    EventHub.trigger('sidebarView:setActive', '#personal');
    EventHub.trigger('header:setName', 'Denuncias');
    this.showLayout('select-category', () => ({'content-row': [new SelectCategoryView()],}));
    var params = {assigned: true };
    params.assigned = undefined;
    params.admin = true;
    params.optval = query['value'];
    EventHub.trigger('reports:resetState');
    EventHub.trigger('category:render', params);
  },

  userViewer: function(userId, type) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#home');
    this.showLayout('user', () => ({filter: new FilterView(), 'content-row': [new(Backbone.View.extend({tagName: "div",className: "map-view col-xs-6",})),]}));
    EventHub.trigger('filter:setState', {type: type || 'all',url: (t) => `user/${userId}/${t}`});
  },

  reportViewer: function(reportID) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#report');
    var currentView = 'Detalle de denuncia ' + reportID;
    EventHub.trigger('header:setName', currentView);
    this.showLayout('report', () => ({content: [new ReportView()]}));
    var categoryPromise = getReportCategoryService().fetch({all: true,cache: false});
    var reportPromise = getReportService().fetch({
      all: true,
      cache: false,
      rules: {
        equals: [{
          key: 'objectId',
          val: reportID
        }]
      }
    });
    //Parse.Promise.when([reportPromise, categoryPromise]).then(([reportsCollection, categoriesCollection]) => {
      EventHub.trigger('report:setState', {reportID: reportID});
    //});
  },
  
  supportTicketViewer: function(supportTicketID) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('sidebarView:setActive', '#supportTicket');
    var currentView = 'Detalle del ticket ' + supportTicketID;
    EventHub.trigger('header:setName', currentView);
    this.showLayout('supportTicket', () => ({content: [new SupportTicketView()]}));
    EventHub.trigger('supportTicket:setState', {supportTicketID: supportTicketID});
  },

  guidesViewer: function(querystring = null) {
    var uri = new URIJS('?' + querystring);
    var query = uri.search(true);
    var id = query['id'];
    var currentView = 'Manual interactivo';
    EventHub.trigger('header:setName', currentView);
    EventHub.trigger('sidebarView:setMenu', 'guides_menu');
    this.showLayout('guides', () => ({'content-row': [new GuidesView()]}));
    EventHub.trigger('guides:setGuide', {id: id});
  },

  categoryViewer: function(querystring = null) {
    EventHub.trigger('sidebarView:setMenu', 'dashboard_menu');
    EventHub.trigger('header:setName', 'Vista por Categoría');
    var uri = new URIJS('?' + querystring);
    var query = uri.search(true);
    var categoryID = query['categoryID'];
    var status = query['status'];
    var assigned;
    var myreps = query.my;
    if(query.assign){
      assigned = true;
      query.assign = true;
      query.my = false;
    }
    if(myreps){
      query.my = true;
    }
    EventHub.trigger('sidebarView:setActive', '#category');
    this.showLayout('report', () => ({content: [new CategoryView()]}));
    EventHub.trigger('reports:resetState');
    var conditions =[];
    conditions.push({
      key: 'superCat',
      val: {
        __type: "Pointer",
        className: "superCategory",
        objectId: categoryID
      }
    });
    if(status == 'open'){
      conditions.push({key: 'active',val: true});
    }
    var subCategoryPromise = getReportSubCategoryService().fetch({
      all: true,
      cache: false,
      rules: {
        equals: conditions
      }
    });
    var categoryPromise = getReportCategoryService().fetchById( categoryID,{cache: false});
      Parse.Promise.when(subCategoryPromise,categoryPromise).then((categoriesCollection,categoryData) => {
        var user = Parse.User.current();
        var subcats = [];
        for (var i = 0; i < categoriesCollection.models.length; i++) {
          subcats.push(categoriesCollection.models[i].id);
        };
        Parse.Cloud.run('GetReportsbySubCategory', {subcategories: subcats, query: query, user: user.id}).then(function(reports) {
          EventHub.trigger('category:setState', {
            reports: reports,
            category: categoryData,
            subcategories: categoriesCollection,
            status : status,
            assigned : assigned,
            my: myreps
          });
        });
      });
  },
});
export default AppRouter;
